<mat-card>
  <mat-card-header class="mat-header__title">
    <mat-card-title>{{
      previewUrl ? previewTitle : ("global.imagePreview" | transloco)
    }}</mat-card-title>
    <!-- <mat-card-subtitle>
      {{
        previewUrl ? previewImageName : ("global.noImageAvailable" | transloco)
      }}</mat-card-subtitle
    > -->
  </mat-card-header>
  <img
    class="upload-preview__image"
    mat-card-image
    [src]="
      previewUrl
        ? previewUrl
        : '../../../../assets/images/image-placeholder.png'
    "
  />
  <div *ngIf="previewUrl" class="preview-overlay">
    <div class="preview-overlay--btn">
      <button
        mat-icon-button
        color="accent"
        (click)="opetConfirmDeleteModal()"
        [matTooltip]="'global.delete' | transloco"
      >
        <mat-icon>delete_forever</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
